import script from "./HoverInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./HoverInfo.vue?vue&type=script&setup=true&lang=js"

import "./HoverInfo.vue?vue&type=style&index=0&id=bec48b84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bec48b84"]])

export default __exports__